<template>
<div>
  <div class="row">
      <div class="col-md-12">
        <h3 class="title">{{ $t('manage_trainers') }}</h3>
      </div>
      <div class="col-md-12 card">
          <div class="card-header">
              <div class="row">
                  <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm"
                      :placeholder="$t('search')"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
              </div>
          </div>
          <div class="card-body">
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                    <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
                       <template slot-scope="props">
                            <p-button type="primary" size="sm" icon @click="handleEditModal(props.$index, props.row)">
                              <i class="fa fa-edit"></i>
                            </p-button>
                            <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                              <i class="fa fa-times"></i>
                            </p-button>
                       </template>
                    </el-table-column>
                  </el-table>
             </div>

          </div>
          <div class="card-footer">
             <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{ $t('showing') }} {{pagination.from}} {{ $t('to') }} {{pagination.to}} {{ $t('of') }} {{pagination.total}} {{ $t('entries') }}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
             </div>
          </div>
      </div>

  </div>

    <div class="row mt-4">
        <div class="navBottom pull-right">
              <p-button class="btn btn-deepDark">
                  <span>{{ $t('add_foundation') }}</span> <i class="fa fa-plus" style="padding-left:15px"></i>
              </p-button>
              <p-button class="btn btn-yellow">
                  <span>{{ $t('add_station') }}</span> <i class="fa fa-plus" style="padding-left:15px"></i>
              </p-button>
        </div>
    </div>

    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('edit_trainer_details') }}</h4>
      <ValidationObserver ref="userForm">
        <form>
           <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.name" :placeholder="$t('name')" :label="$t('name')"></fg-input>
          </ValidationProvider>
           <ValidationProvider name="surname" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.surname" :placeholder="$t('surname')" :label="$t('surname')"></fg-input>
          </ValidationProvider>
          <ValidationProvider name="email" rules="required|email|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.email" :placeholder="$t('email')" :label="$t('email')"></fg-input>
          </ValidationProvider>
          <fg-input :label="$t('country')">
            <el-select size="large" class="select-primary" v-model="form.location_ID" filterable clearable :placeholder="$t('select_country')">
                <el-option
                  class="select-primary"
                  v-for="country in Countries"
                  :key="country.id"
                  :label="country.name"
                  :value="country.id"></el-option>
            </el-select>
          </fg-input>
          <fg-input :label="$t('ngo_foundation')">
              <el-select size="large" class="select-primary" v-model="form.ngo_ID" filterable clearable :placeholder="$t('select_ngo')">
                  <el-option
                    class="select-primary"
                    v-for="ngo in NGO"
                    :key="ngo.id"
                    :label="ngo.name"
                    :value="ngo.id"></el-option>
              </el-select>
          </fg-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click.native="modals.classic = false">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="updateUser">{{ $t('update') }}</p-button>
        </div>
      </template>
    </modal>

</div>
</template>
<script>
  import Resource from "@/util/Api/resource.js";
  import PPagination from "src/components/UIComponents/Pagination.vue";
  import Modal from "src/components/UIComponents/Modal.vue";
  import { Message } from "element-ui";

  const TrainerResource = new Resource("user/list");
  const CatResources = new Resource("category/childrenGivenParent");
  const UpdateUserResource = new Resource("user/update");
  const UserDeleteResource = new Resource("user/delete");

  export default {
      components: {
        PPagination,
        Modal,
     },
     data() {
       return {
          tableColumns: [
            {prop: "name",label: this.$t("name"),},
            {prop: "surname",label: this.$t("surname"),},
            {prop: "email",label: this.$t("email"),},
            {prop: "ngo_Name",label: this.$t("foundation"),},
            {prop: "location_Name",label: this.$t("in_country")},
          ],
          modals: {
            classic: false
          },
          loading: false,
          searchQuery: "",
          tableData: [],
          NGO:[],
          Countries:[],
          form:{
             userID:'',
             roleID:'',
             name:'',
             surname:'',
             email:'',
             location_ID:'',
             ngo_ID:'',
             countryName:'',
             ngoName:'',
          },
          auth_user_id: localStorage.getItem("id"),
          pagination:{
              perPage: 10,
              perPageOptions: [10, 20, 30, 60, 500, 1000],
              currentPage:1,
              nextPage:'',
              prevPage:'',
              total:'',
              from:'',
              to:'',
              page:'',
          },
       }
     },

     methods: {

        handleCloseModal() {
          this.modals.classic = false;
          this.getAllTrainers();
          this.updateState = false;
        },

        // show message dialog
        showAlertMessage(message, type) {
          this.$message.closeAll();
          this.$message({
            type: type,
            message: message
          });
        },

        // edit modal
        async handleEditModal(index, row){
            this.form.userID = row.id;
            this.form.roleID = row.roleID;
            this.form.name = row.name;
            this.form.surname = row.surname;
            this.form.email = row.email;
            this.form.location_ID = row.location_ID;
            this.form.ngo_ID = row.ngo_ID;
            this.modals.classic = true;
        },

        // get all trainers
        async getAllTrainers(){
            this.loading = true;
            await TrainerResource.get(3).then((response) => {
              this.tableData = response.data;
              this.loading = false;
            }).catch((error) => {
              this.showAlertMessage(error.response.data.message, "error");
            });
        },

        // Get all NGOs in a categories
        async getNGOs() {
          await CatResources.get(1).then(response => {
            this.NGO = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },

        // Get all countries in a category
        async getCountry() {
          await CatResources.get(2).then(response => {
            this.Countries = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },

        // update user info
        async updateUser() {
          this.form.createdBy = this.auth_user_id;
          await UpdateUserResource.updateUser(this.form)
            .then(response => {
              this.getAllTrainers();
              this.handleCloseModal();
              this.showAlertMessage(this.$t("user_updated_successfully"), "success");
            }).catch(error => {
              this.showAlertMessage(error.response.data.message, "error");
              if (error.response.data.errors) {
                this.$refs.userForm.setErrors(
                  error.response.data.errors
                );
              }
            });
        },

        handleDelete(index, row) {
          this.$confirm(
            "Are you sure you want to delete this trainer?",
            "Warning",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "Cancel",
              cancelButtonClass: "btn-danger",
              confirmButtonClass: "btn-primary",
              type: "warning"
            }
          ).then(() => {
              let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === row.id
              );
              if (indexToDelete >= 0) {
                this.form = row;
                UserDeleteResource.deleteWithGet(this.form.id)
                  .then(response => {
                    this.tableData.splice(indexToDelete, 1);
                    this.getAllTrainers();
                    this.showAlertMessage("Deleted Successfully", "success");
                  }).catch(error => {
                    this.showAlertMessage(error.response.data.message, "error");
                  });
              }
            }).catch(() => {});
        },

        paginate(array, length, pageNumber){
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            this.pagination.page = Math.ceil(array.length / length);
            this.pagination.total = array.length;
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },

     },

     created() {
        this.getAllTrainers();
        this.getNGOs();
        this.getCountry();
     },

     computed: {

        queriedData() {
            let result = this.tableData;
            if (this.searchQuery) {
                result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                    })
                })
            }
            return result;
        },

        paginated(){
            return this.paginate(this.queriedData, this.pagination.perPage, this.pagination.currentPage);
        },

     },
  }
</script>
<style scoped>

  .btn-deepDark {
      background-color: #000000;
      color: white;
      margin-right: 10px;
  }

  .btn-yellow {
     background-color: #FEB936;
     color: #000000;
  }

  .navBottom {
      display: flex;
      position: absolute;
      right: 15px;
      /* width: 330px; */
      bottom: 70px;
  }

</style>
